var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"body-1"},[_vm._v("\n      "+_vm._s(_vm.$t('Put this code on the pages where you want the widget to appear'))+"\n    ")]),_vm._v(" "),_c('code-block',{staticClass:"mb-4",attrs:{"language":"html","code":`<script
  ${_vm.useOnAllPagesScript}
></script>`},on:{"copy-success":() => _vm.$root.$snack('success', 'Copied to clipboard', 1500),"copy-error":() => _vm.$root.$snack('error', 'Could not copy to clipboard', 1500)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }